import { statusLabelKeyOrNull } from '@bookingdei/i18n/status-label';
import type { StatusEntity } from '@bookingdei/i18n/status-label';
import { statusToneOrNeutral } from '@bookingdei/i18n/status-tone';
import { tone } from '../theme/tokens';
import { useLanguage } from './language-context';

// Status chip (CB-15, CB-17). Label from `statusLabelKey()`, colour from
// `statusTone()` mapped to this surface's tone tokens (theme/tokens.ts). Unknown
// wire values render their raw value on the neutral tone (AP-D10). Defaults to the
// booking lifecycle; pass `entity` for other canonical enumerations.
export function StatusBadge({
  status,
  entity = 'booking_status',
}: {
  status: string;
  entity?: StatusEntity;
}) {
  const { t } = useLanguage();
  const key = statusLabelKeyOrNull(entity, status);
  const c = tone[statusToneOrNeutral(entity, status)];
  return (
    <span className="status-badge" style={{ color: c.fg, background: c.bg }}>
      {key ? t(key) : status}
    </span>
  );
}
